import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const enum BulletNoteCategory {
  ERROR = 'error',
  INFO = 'info',
  WARN = 'warn'
}

export interface Bulletin {
  id: string
  createdAt: string
  updatedAt: string
  publishedAt: string
  revisedAt: string
  unpublishedAt: string
  note: string
  category: BulletNoteCategory[]
}

const X_MICROCMS_API_KEY = import.meta.env.VITE_MICROCMS_API_KEY
const BASE_URL = import.meta.env.VITE_MICROCMS_BASE_URL
const NOW = new Date().toISOString()
const BULLETIN_URL = `${BASE_URL}/bulletin?filters=publishedAt[less_than]${NOW}[and]unpublishedAt[greater_than]${NOW}&orders=-publishedAt`

export const useBulletInStore = defineStore('bulletIn', () => {
  const storedDismissedBulletInIds: string | null = localStorage.getItem('dismissedBulletInIds')
  const bulletIn = ref<Bulletin | null>(null)
  const bulletInList = ref<Bulletin[] | []>([])
  const dismissedBulletInIds = ref<Set<string>>(
    new Set(JSON.parse(storedDismissedBulletInIds ?? '[]'))
  )
  const isBulletInAvailable = computed(() => bulletIn.value !== null)

  const fetchBulletIn = () => {
    fetch(BULLETIN_URL, {
      headers: {
        'X-MICROCMS-API-KEY': X_MICROCMS_API_KEY
      }
    })
      .then((response) => response.json())
      .then((data) => {
        bulletInList.value = data.contents
        setFirstNonDismissedBulletIn()
      })
      .catch(console.error)
  }

  const setFirstNonDismissedBulletIn = () => {
    bulletIn.value =
      bulletInList.value.find((item) => !dismissedBulletInIds.value.has(item.id)) || null
  }

  const dismissBulletIn = () => {
    if (bulletIn.value) {
      dismissedBulletInIds.value.add(bulletIn.value.id)
      localStorage.setItem('dismissedBulletInIds', JSON.stringify(dismissedBulletInIds.value))
      setFirstNonDismissedBulletIn()
    }
  }

  return {
    bulletIn,
    isBulletInAvailable,
    fetchBulletIn,
    dismissBulletIn
  }
})
